// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"895":"90983db0","909":"fbe6db33"}[chunkId] + ".chunk.css";
};